/**
 * Safe stringify object to JSON
 *
 * This util remove any circular references
 */
export const jsonStringify = (json: unknown) => {
    try {
        const visitedObjects = new Set<unknown>();

        return JSON.stringify(json, (key: string, value: unknown) => {
            if (typeof value === 'object' && value !== null) {
                // Exclude key, contains duplicated reference
                if (visitedObjects.has(value)) return;
                // Remember visited object
                visitedObjects.add(value);
            }
            return value;
        });
    } catch (e) {
        return '[unserializable]';
    }
};
